import { Grid, MenuItem } from "@mui/material";
import React from "react";
import { Property } from "src/interfaces/IProperty";
import Select from "../../../UI/Select";
import { Sorter } from "../utils";

export default function PropertySelector({
  properties,
  selectedName,
  onSelect,
}: {
  properties: Property[];
  selectedName?: string;
  onSelect: (propertyName: string) => void;
}) {
  return (
    <Grid container item sm={12} md={3}>
      <Select
        label="Property"
        sx={{ flex: "1 1 100%" }}
        value={selectedName || ""}
        onChange={(propertyName) => onSelect(propertyName)}
      >
        {properties.sort(Sorter.property).map((property: Property) => (
          <MenuItem value={property.property_name} key={property.property_name}>
            {property.property_name}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}
